var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"spreadqrcode"},[_c('img',{class:_vm.isVip ? 'vip' : '',attrs:{"id":"qrcode","src":_vm.qrCode}})])])}
var staticRenderFns = []

export { render, staticRenderFns }